import React, { useEffect, useMemo } from "react";

import { AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet";

import Sidebar from "./sidebar";
import { ProjectData } from "./sidebar/project";
import ProjectInformation from "./projects/information";

// Hook to get projects
import { getProjects } from "./projects";

function Home() {
  const Projects = useMemo(() => getProjects(), []);
  const [selectedProject, setSelectedProject] =
    React.useState<ProjectData | null>(null);

  function onProjectClick(project: ProjectData) {
    // CHANGE URL
    window.history.pushState({}, "", project.title);
    setSelectedProject(project);
  }

  useEffect(() => {
    //LOAD PROJECT FROM URL
    const pathname = decodeURI(window.location.pathname.substring(1));
    if (pathname && !selectedProject && Projects.length > 0) {
      const project = Projects.find((project) => project.title === pathname);
      if (project) {
        setSelectedProject(project);
      }
    }
  }, [selectedProject, Projects]);

  return (
    <div className="bg-white h-screen w-screen flex">
      {/* META */}
      {selectedProject && (
        <Helmet>
          <title>{selectedProject.title} - Huu Khoa</title>
          <link
            rel="canonical"
            href={`https://huu-khoa.com/${encodeURIComponent(
              selectedProject.title
            )}`}
          />
          <meta name="description" content={selectedProject.description} />
          <link rel="icon" href={selectedProject.thumbnail} />
        </Helmet>
      )}

      {!selectedProject && (
        <Helmet>
          <title>Huu Khoa's Portfolio</title>
          <link rel="canonical" href="https://huu-khoa.com" />
          <meta name="description" content={"..."} />
          <link rel="icon" href={"/images/huukhoa.png"} />
        </Helmet>
      )}

      {/* SIDE BAR */}
      <Sidebar
        projects={Projects}
        onProjectClick={onProjectClick}
        selectedProject={selectedProject}
      />

      {/* PROJECT */}
      <div className={"flex-1"}>
        <AnimatePresence initial={false} mode={"wait"}>
          {selectedProject && (
            <div
              className={
                "top-0 start-0 right-0 bottom-0 absolute w-screen h-screen bg-white xl:bg-transparent xl:w-full xl:h-full xl:relative overflow-y-scroll"
              }
              key={selectedProject?.title}
            >
              <ProjectInformation
                project={selectedProject}
                close={() => setSelectedProject(null)}
              />
            </div>
          )}
        </AnimatePresence>

        {!selectedProject && (
          <div
            className={
              "flex-1 h-full flex items-center justify-center max-md:hidden"
            }
          >
            <div className={"text-center"}>
              <h1 className={"text-4xl font-bold"}>Welcome to my Project 👋</h1>
              <p className={"text-gray-500"}>Tap on a project to see more.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
export default Home;
